import React, { useCallback, useRef, useState } from "react";
import CommonTooltip from "./CommonTooltip";

// Truncated text that shows its full value in the shared blue CommonTooltip, only when it is
// actually clipped. Overflow is measured on hover: the outer span's mouseenter runs in the same
// batch as the tooltip's own, so the bubble is already enabled when it first renders.
const OverflowTooltipText = ({ text, className = "", dir }) => {
  const triggerRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const measureOverflow = useCallback(() => {
    const node = triggerRef.current;
    if (node) setIsOverflowing(node.scrollWidth > node.clientWidth);
  }, []);

  return (
    <span className="block min-w-0 max-w-full" onMouseEnter={measureOverflow}>
      <CommonTooltip
        text={text === null || text === undefined || text === "" ? "" : String(text)}
        position="top"
        disableDefaultDescription
        className="block min-w-0 max-w-full cursor-default"
        tooltipClassName={`w-max max-w-[min(20rem,calc(100vw-1.5rem))] [text-wrap:balance] ${isOverflowing ? "" : "hidden"}`}
        fitContent
        clampToViewport
        hoverOnly
      >
        <span
          ref={triggerRef}
          dir={dir}
          className={`block min-w-0 truncate ${className}`}
        >
          {text}
        </span>
      </CommonTooltip>
    </span>
  );
};

export default OverflowTooltipText;
